import { ThemeProvider } from 'styled-components';
import './shared/global.css';
export default ThemeProvider;